<template>
  <div class="flex items-center cell cell-renderer-item">

    <!-- TODO: 簡易的にv-modelに式を書いてセットしているので、双方向通信ができていない。ag-grid-vueのrowDataにダイレクトに変更を伝えるには、別途対応が必要。-->

    <div v-if="params.value && params.value.columnKey=='progress'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div 
        class="cell-input-basic"
      >{{getValueMapSafely(params).value ? getValueMapSafely(params).value : '-'}}</div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='progress_at'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div 
        class="cell-input-basic"
      >{{ formattedTimeForProgress(getValueMapSafely(params)) ? formattedTimeForProgress(getValueMapSafely(params)) : '-'}}</div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='order_type'" class="flex items-center pm-ag-grid-inner-cell padding-cell">  
      <div 
        class="cell-input-basic"
        v-if="getValueMapSafely(params).name || getValueMapSafely(params).value || getValueMapSafely(params).id"
      >{{ getValueMapSafely(params).name || getValueMapSafely(params).value || getValueMapSafely(params).id }}</div>
      <div 
        class="cell-input-basic"
        v-else
      >-</div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='order_at'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div 
        class="cell-input-basic"
      >{{formattedTime(getValueMapSafely(params)) ? formattedTime(getValueMapSafely(params)) : '-'}}</div>
    </div>

    <div v-else-if="params.value && ['rope_boats', 'vehicles', 'tug_boats'].includes(params.value.columnKey)" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <!-- 件数表示の場合 is_count === true -->
      <div v-if="getValueMapSafely(params).is_count === true" class="flex items-center pm-ag-grid-inner-cell" >
        <div v-if="getValueMapSafely(params).count"  class="flex items-center pm-ag-grid-inner-cell">
          <div class="cell-input-basic">
            {{ getValueMapSafely(params).count }}T
          </div>
        </div>
        <template v-else>
          <div
            class="flex items-center pm-ag-grid-inner-cell"
            v-for="index in loopCountByColumn(params.value.columnKey)"
            :key="index"
          >
            <div class="cell-input-basic">-</div>
          </div>
        </template>
      </div>

      <!-- 件数表示の場合 is_size === true -->
      <div v-else-if="getValueMapSafely(params).is_size === true" class="flex items-center pm-ag-grid-inner-cell" >
        <div v-if="getValueMapSafely(params).value && getValueMapSafely(params).value.filter(x => [2,3].includes(x.status)).length > 0" class="flex items-center pm-ag-grid-inner-cell padding-cell" >
          <div class="cell-input-basic">
            {{ getValueMapSafely(params).value.filter(x => [2,3].includes(x.status)).length }}T
          </div>
        </div>
        <template v-else>
          <div
            class="flex items-center pm-ag-grid-inner-cell padding-cell"
            v-for="index in loopCountByColumn(params.value.columnKey)"
            :key="index"
          >
            <div class="cell-input-basic">-</div>
          </div>
        </template>
      </div>

      <!-- 名称列挙の場合 -->
      <div v-else class="flex items-center pm-ag-grid-inner-cell" >
        <div v-if="getValueMapSafely(params).value && getValueMapSafely(params).value.filter(x => [2,3].includes(x.status)).length > 0" class="flex items-center pm-ag-grid-inner-cell padding-cell" >
          <div class="cell-input-basic">
            <div v-for="(equipment,index) in getValueMapSafely(params).value.filter(x => [2,3].includes(x.status))" :key="index"  class="flex items-center pm-ag-grid-inner-cell">
              {{ equipment.short_name || ( equipment.name ? equipment.name.slice(0,3) : null ) }}
            </div>
          </div>
        </div>
        <template v-else>
          <div class="cell-input-basic">
            <div
              class="flex items-center pm-ag-grid-inner-cell"
              v-for="index in loopCountByColumn(params.value.columnKey)"
              :key="index"
            >
              -
            </div>
          </div>
        </template>
      </div>

    </div>

    <div v-else-if="params.value && params.value.columnKey=='previous'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div v-if="getValueMapSafely(params).order_type != '3' "
        class="cell-input-basic">
        {{ getValueMapSafely(params).port_name ? getValueMapSafely(params).port_name : '-' }}
      </div>
      <div v-else-if="getValueMapSafely(params).order_type == '3' "
        class="cell-input-basic" >
        <span v-if="getValueMapSafely(params).berth && Object.keys(getValueMapSafely(params).berth).length != 0">
          <span :style="{'border-left': '4px solid ' + '#' + getColorHex(getValueMapSafely(params).berth.color)}">
            {{ getValueMapSafely(params).berth && ( getValueMapSafely(params).berth.label || getValueMapSafely(params).berth.name ) }}
          </span>
        </span>
        <span v-else>
          -
        </span>
      </div>

    </div>

    <div v-else-if="params.value && params.value.columnKey=='berth'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div
        class="cell-input-basic"
      >
        <span
          class="color-cell-content"
          v-if="Object.keys(getValueMapSafely(params)).length != 0"
          :style="{'border-left': '4px solid ' + '#' + getColorHex(getValueMapSafely(params).color)}">
          {{getValueMapSafely(params).label || getValueMapSafely(params).name}}
        </span>
        <span v-else>
          -
        </span>
      </div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='head_count'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div 
        class="cell-input-basic"
      >
        <div v-if="getValueMapSafely(params).value && getValueMapSafely(params).value.length > 0 ">
          <span v-for="( headCount, index ) in getValueMapSafely(params).value" :key="index">
            <span :style="{color:headCountColorCode(getValueMapSafely(params).color_id[index])}" class="pm-literal-margin">{{ headCount }}</span>
          </span>
        </div>
        <span v-else>
          -
        </span>
      </div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='flag'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div 
        class="cell-input-basic"
      >{{getValueMapSafely(params).value ? getValueMapSafely(params).value : '-'}}</div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='bit'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <vs-row vs-w="12" class="cell-input-basic">
        <vs-col  vs-w="4">
          <span :style="{color: getValueMapSafely(params).left_options && getValueMapSafely(params).left_options.required ? '#D24C37' : null}"  class="pm-literal-margin">{{getValueMapSafely(params).left ? getValueMapSafely(params).left : '-'}}</span>
        </vs-col>
        <vs-col  vs-w="4" v-if="getValueMapSafely(params).left && getValueMapSafely(params).right">
        〜 
        </vs-col>
        <vs-col  vs-w="4">
          <span :style="{color: getValueMapSafely(params).right_options && getValueMapSafely(params).right_options.required ? '#D24C37' : null}"  class="pm-literal-margin">{{getValueMapSafely(params).right ? getValueMapSafely(params).right : '-'}}</span>
        </vs-col>
      </vs-row>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='boardside_type'" class="flex items-center pm-ag-grid-inner-cell">
      <div v-if="getValueMapSafely(params).id && [1,2,3,4,5].includes(getValueMapSafely(params).id)" class="flex items-center pm-ag-grid-inner-cell padding-cell" >
        <div class="cell-input-basic">
          {{ 
            getValueMapSafely(params).id === 1 ? '左' :
            getValueMapSafely(params).id === 2 ? '右' : 
            getValueMapSafely(params).id === 3 ? '左' :
            getValueMapSafely(params).id === 4 ? '右' :
            getValueMapSafely(params).id === 5 ? '？' : ""
          }}
          <feather-icon v-if="getValueMapSafely(params).id === 3 || getValueMapSafely(params).id === 4" icon="RefreshCwIcon"  svgClasses="h-4 w-4" class="pm-boardside-type-icon" />
        </div>
      </div>
      <div v-else class="flex items-center pm-ag-grid-inner-cell padding-cell" >
        <div class="cell-input-basic">
          -
        </div>
      </div>
    </div>

    <div v-else-if="params.value && ['pilot', 'team_leader'].includes(params.value.columnKey)" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div v-if="getValueMapSafely(params) && [2,3].includes(getValueMapSafely(params).status) && ( getValueMapSafely(params).short_name || getValueMapSafely(params).name )" 
        class="cell-input-basic"
      >
        {{ getValueMapSafely(params) && [2,3].includes(getValueMapSafely(params).status) && 
            ( getValueMapSafely(params).short_name || ( getValueMapSafely(params).name ? getValueMapSafely(params).name.slice(0,3) : null )) }}
      </div>
      <div v-else class="cell-input-basic">
        -
      </div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='caution_note'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div 
        class="cell-input-basic"
        v-if="getValueMapSafely(params).value && getValueMapSafely(params).value.length > 0"
      >
        <feather-icon icon="AlertCircleIcon" svgClasses="h-6 w-6" class="mr-2" />
      </div>
      <div v-else class="cell-input-basic">
        -
      </div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='weather'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div 
        class="cell-input-basic"
        v-if="getValueMapSafely(params).id"
      >
        <feather-icon v-if="getValueMapSafely(params).id === '1'"  icon="WindIcon"      svgClasses="h-6 w-6" class="mr-2" />
        <img v-if="getValueMapSafely(params).id === '2'" :src="rainDarkIcon" class="mr-2 h-6 w-6" />
        <img v-if="getValueMapSafely(params).id === '3'" :src="snowDarkIcon" class="mr-2 h-6 w-6" />
      </div>
      <div v-else class="cell-input-basic">
        -
      </div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='shipping_agency'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div 
        class="cell-input-basic"
        v-if="getValueMapSafely(params).id"
      >{{getValueMapSafely(params).short_name}}</div>
      <div v-else class="cell-input-basic">
        -
      </div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='vessel'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div
        v-if="getValueMapSafely(params).order_type == '4' && getValueMapSafely(params).task_name"
        class="cell-input-basic"
      >{{ getValueMapSafely(params).task_name }}</div>
      <div
        v-else-if="getValueMapSafely(params).order_type != '4' && getValueMapSafely(params).enterprisePortVessel && ( getValueMapSafely(params).enterprisePortVessel.name || getValueMapSafely(params).enterprisePortVessel.label )"
        class="cell-input-basic"
      >{{ vesselNameJapaneseFlg ? getValueMapSafely(params).enterprisePortVessel.label || getValueMapSafely(params).enterprisePortVessel.name : getValueMapSafely(params).enterprisePortVessel.name }}</div>
      <div v-else class="cell-input-basic">
        -
      </div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='required_note'" class="flex items-center pm-ag-grid-inner-cell padding-cell">
      <div 
        class="cell-input-basic"
        v-if="getInputValue"
      >
      {{getValueMapSafely(params).value}}</div>
      <div v-else class="cell-input-basic">
        -
      </div>
    </div>

    <div
      v-else-if="params.value && params.value.columnKey=='sort_order'"
      class="flex items-center pm-ag-grid-inner-cell functions"
    >
      <div v-if="params.context.dragDisabled" class="trash-icon mr-2" @click="popupActive = true"><feather-icon icon="TrashIcon" svgClasses="h-4 w-4" /></div>
    </div>

    <div v-else-if="params.value && params.value.columnKey=='input_type'" class="flex items-center pm-ag-grid-inner-cell functions">
      <feather-icon v-if="getValueMapSafely(params).value != 2" icon="EditIcon" svgClasses="h-4 w-4" class="edit-icon mr-2" />
    </div>

    <vs-popup v-if="params.value && params.value.columnKey=='sort_order'" class="cell-renderer-delete-popup"  title="登録データの削除" :active.sync="popupActive">
      <p>
        選択した項目を削除しますか？
      </p>
      <div class="button-area">
        <vs-button class="popup-button" color="#BDBDBD" @click="popupActive = false">キャンセル</vs-button>
        <vs-button class="popup-button" color="#2D9CDB" @click="callDelete(params.value.taskId)">削除</vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");
const { mapState: mapStateOfPortMaster } = createNamespacedHelpers("portMaster");
import moment from "moment-timezone";

export default {
  name: "CellRendererItem",
  components: {
  },
  data() {
    return {
      popupActive: false,
      snowDarkIcon: require(`@/assets/images/icons/port-master/snow_dark.svg`),
      rainDarkIcon: require(`@/assets/images/icons/port-master/rain_dark.svg`),
    }
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      destinationWorkHeaders: state => state.destinationWorkHeaders,
      vesselNameJapaneseFlg: state => state.vesselNameJapaneseFlg,
      isImportEdit: state => state.isImportEdit,
      selectedDateDisplay1: state => state.selectedDateDisplay1,
    }),
    ...mapStateOfPortMaster({
      selectedPort: state => state.selectedPort,
    }),  
    getInputValue() {
      let valueMap = this.getValueMapSafely(this.params);
      if (Array.isArray(valueMap)) {
        return valueMap;
      } else {
        return this.getValueMapSafely(this.params).name || this.getValueMapSafely(this.params).value || this.getValueMapSafely(this.params).id;
      }
    },
    getValueMapSafely() {
      return params => {
        if ( params && params.value && params.value.valueMap ) {
          return params.value.valueMap;
        } else {
          return {};
        }
      }
    },
  },
  methods: {
    ...mapActions(["updateFirestoreDocument", "deleteDestinationWorkOneTask", "deleteDestinationWorkImportedOneTask"]),
    async callDelete(id) {
      this.$vs.loading()
      if (this.isImportEdit) {
        const payload = {
          id: id,
          date: this.selectedDateDisplay1,
        }
        this.deleteDestinationWorkImportedOneTask(payload)
      } else {
        const payload = {
          id: id,
          selectedPort: this.selectedPort,
        }
        await this.deleteDestinationWorkOneTask(payload)
      }
      this.popupActive = false
    },
    formattedTime( dateValue ) {
      if ( ! dateValue || ! dateValue.value) {
        return "";
      }
      return moment(dateValue.value).local().format("DD HH:mm");
    },
    loopCountByColumn(columnKey) {
      if (columnKey == 'vehicles') {
        return 3
      } else {
        return 1
      }
    },
    formattedTimeForProgress( dateValue ) {
      if ( ! dateValue || ! dateValue.value || ! dateValue.progress  || ! dateValue.value[dateValue.progress] ) {
        return "";
      }
      return moment(dateValue.value[dateValue.progress].seconds * 1000).local().format("HH:mm");
    },
    bitColorCode(colorId){
      let colorObj = this.masterMap['bit_colors'].find(color => color.id === colorId);
      return colorObj ? colorObj.value : null;
    },
    headCountColorCode(colorId){
      let colorObj = this.masterMap['head_count_colors'].find(color => color.id === colorId);
      return colorObj ? colorObj.value : null;
    },
    progressColorCode(colorId) {
      let colorObj = this.masterMap['progress_colors'].find(color => color.id === colorId);
      return colorObj ? colorObj.value : null;
    },
    itemColor(equipment) {
      let itemColorCode = '#828282';
      if ( equipment.status === 2 ) {
        itemColorCode = '#081e29';
      } else if (equipment.status === 3 ) {
        itemColorCode = '#21526d';
      }
      return itemColorCode;
    },
    itemTransparent(equipment) {
      let isTransparent = false;
      if ( equipment.status === 2 ) {
        isTransparent = true;
      }
      return isTransparent;
    },
    getColorHex(color) {
      if (color == null || color == undefined) {
        return 'ffffff00'
      } else if (Object.prototype.hasOwnProperty.call(color, "color_hex")){
        return color.color_hex
      }
    }

  },
  mounted() {
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.cell-renderer-item {
  width: 100%;
  .cell-input-basic {
    border: solid 1px transparent;
    border-radius: 5px;
    padding: 0px 3px;
    color: $pm-dark-gray;
    width: 100%;
    height: 40px;
    cursor: pointer;
    transition: 0.3s;
    display: flex;
    align-items: center;
    -ms-overflow-style: none;    /* IE, Edge 対応 */
    scrollbar-width: none;       /* Firefox 対応 */
    overflow: auto;
    &:hover {
      border: solid 1px $pm-blue;
      background: $pm-transparent-blue;
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .padding-cell {
    padding: 0px 2px;
  }

  .cell {
    width: inherit;
  }
  .color-cell-content {
    line-height: 1.8rem;
    padding-left: 0.4rem;
  }

  .ag-grid-cell-chip {
      border-radius: 5px;
    &.vs-chip-success {
      background: rgba(var(--vs-success), 0.15);
      color: rgba(var(--vs-success), 1) !important;
      font-weight: 500;
    }
    &.vs-chip-warning {
      background: rgba(var(--vs-warning), 0.15);
      color: rgba(var(--vs-warning), 1) !important;
      font-weight: 500;
    }
    &.vs-chip-danger {
      background: rgba(var(--vs-danger), 0.15);
      color: rgba(var(--vs-danger), 1) !important;
      font-weight: 500;
    }

  }
  .ag-theme-material .ag-icon-grip {
    &::before {
  // Editでは修正
  //    color: $pm-white;
      color: $pm-black;
      content: 'I'; /* '\0406'; */  /* http://orange-factory.com/sample/utf8/code2.html */
    }
  }

  .pm-ag-grid-inner-cell {
    height:100%;
    width: 100%;
  }

  .pm-chip-with-border {
    border:1px solid $pm-navy;
    background-color: $pm-light-gray !important;

  }
  .pm-chip-without-border {
    border:none;

  }
 
  .pm-boardside-type-icon {
    padding-left: 0.4rem;
  }

  .con-vs-chip {
    margin-top: 0.2rem;
  }
  .blank-circle-plus {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .blank-circle-plus-left {
    display: flex;
    margin-left: 0.2rem;
    align-items: center;
    font-size: 80%;
  }
  .trash-icon {
    cursor: pointer;
    padding-left: 15px;
  }
  .edit-icon {
    padding-left: 15px;
    color: $pm-blue;
  }
  .functions {
    margin-left: auto;
    margin-right: auto;
  }
}
.cell-renderer-delete-popup {
  .popup-button {
    margin-left: 10px;
  }
  .button-area {
    width: fit-content;
    margin-top: 20px;
    margin-left: auto;
  }
}
</style>
